import React, { useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import Footer from "../pallet/Footer";
import StorageLocationAutocomplete from "../../../../views/capture/RackLocations/StorageLocationAutocomplete/StorageLocationAutocomplete";
import useAuth from "src/hooks/useAuth";

const styles = {
  button: {
    minWidth: 100,
  },
};

export default function Step3({ onBack, onUpdateLocations, projectId, total, value }) {
  const [selectedLocations, setSelectedLocations] = useState([value]);
  const { user } = useAuth();
  const { settings } = user.company;

  const handleSubmit = () => {
    onUpdateLocations(selectedLocations);
  };

  const handleQuantityChange = (index, value) => {
    if (Number(value) > total) {
      return;
    }

    const newLocations = [...selectedLocations];
    newLocations[index] = {
      ...newLocations[index],
      sub_qty: Number(value) || 0,
    };
    setSelectedLocations(newLocations);
  };

  return (
    <>
      <DialogContent>
        <Box textAlign="center" mb={3} minHeight={300} display="flex" alignItems="center">
          <Box width="100%">
            <Typography color="textPrimary" mb={4}>
              Which location are we moving to?
            </Typography>
            <Box mt={4} display="flex" flexDirection="column" gap={1.5} mx="auto" maxWidth={500}>
              {selectedLocations.map((location, index) => (
                <Box key={index} display="flex" flexDirection="column" gap={2} alignItems="center">
                  <TextField
                    label="Location QTY"
                    type="number"
                    size="large"
                    value={location.sub_qty || ""}
                    onChange={e => handleQuantityChange(index, e.target.value)}
                    inputProps={{ min: 0 }}
                    sx={{ width: "100%" }}
                    InputLabelProps={{ shrink: true }}
                  />
                  <StorageLocationAutocomplete
                    index={index}
                    autoOpen={selectedLocations.length === 1}
                    name={`location-${index}`}
                    value={location}
                    projectId={projectId}
                    onChange={values => {
                      const newLocations = [{ ...location, ...values }];
                      setSelectedLocations(newLocations);
                      if (settings.receiving_into_pallets) {
                        onUpdateLocations(newLocations);
                      }
                    }}
                    disabled={false}
                    loading={false}
                  />

                  {location.sub_qty > 0 && location.warehouse_locations?.length > 0 ? (
                    <CheckCircleOutlineIcon color="primary" sx={{ fontSize: 34 }} />
                  ) : (
                    <Box width={34} minWidth={34} />
                  )}
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </DialogContent>
      <Footer step={2}>
        <Box />
        <Box display="flex" gap={1}>
          <Button variant="outlined" onClick={onBack} sx={styles.button}>
            Back
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={selectedLocations.some(loc => !loc.warehouse_locations?.length || !loc.sub_qty)}
            sx={styles.button}
          >
            Submit
          </Button>
        </Box>
      </Footer>
    </>
  );
}
